module.exports = __webpack_public_path__ + "img/save_subtitle.e6c2e1d3.png";